module.exports = __webpack_public_path__ + "img/MCSA-Office-365-2018.1da596bb.png";